<rc-order>
  <span order-heading>
    S-a produs o eroare
  </span>
  <span order-content>
  </span>
  <span thanks-heading>
        Ne pare rău pentru neplăcerile create.
    <br />
   Dacă întâmpinați probleme vă rugăm contactați-ne la <a  (click)="trackConversion('Pv7pCN3In6QZELWMoq4q')" [href]="'tel:' + phoneRaw">{{phone}}</a> / <a [href]="'mailto:' + email">{{email}}</a>
  </span>
</rc-order>
